// ModifiersGroup helper functions and data

import { ModifierGroupRenderer } from "artisn/products";

export const getGroupAmount = (modifierGroup: ModifierGroupRenderer) => {
  return modifierGroup?.modifiers.reduce((acc, modifier) => {
    return acc + modifier?.amount;
  }, 0);
};
